import styled from 'styled-components';
export const HeaderContainer = styled.div `
  display: grid;
  gap: 8px;
`;
export const HeaderTitle = styled.h1 `
  font-size: 40px;
  line-height: 56px;
  font-weight: 400;
  letter-spacing: -0.015em;
  color: #000000;
  word-break: break-all;
`;
